__turbopack_context__.v({
  "button": "PlasmicTC-module__8ZLi-G__button",
  "embedHtml": "PlasmicTC-module__8ZLi-G__embedHtml",
  "freeBox": "PlasmicTC-module__8ZLi-G__freeBox",
  "root": "PlasmicTC-module__8ZLi-G__root",
  "svg__mSkP9": "PlasmicTC-module__8ZLi-G__svg__mSkP9",
  "svg__pUpaD": "PlasmicTC-module__8ZLi-G__svg__pUpaD",
  "text": "PlasmicTC-module__8ZLi-G__text",
});
